import PropTypes from 'prop-types';

const If = ({ children, condition }) => (condition ? children : null);

export default If;

If.propTypes = {
  condition: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
  children: PropTypes.node.isRequired,
};
